<template>
  <form @submit.prevent="setStatusAndSubmit">
    <div class="page-wrap p-3">
      <div class="mt-3 mb-3">
        <a :href="`/students-social-payment`">
          <span><i class="fa fa-chevron-left" aria-hidden="true"></i></span>
          Назад
        </a>
      </div>

      <div class="page-header p-3 mb-3 mt-3">
        <h3>Социальные выплаты</h3>
      </div>
    </div>
    <div class="page-content mt-3 mb-3">
      <div class="card">
        <div class="card-header">
          <h6>Личные данные</h6>
        </div>
        <div class="card-body">
          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  ИИН
                </label>
                <div class="col-md-9">
                  {{ student.iin }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  Ф.И.О.
                </label>
                <div class="col-md-9">
                  {{ student.lastname }} {{ student.firstname }}
                  {{ student.patronymic }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  Академическая степень
                </label>
                <div class="col-md-9">
                  {{ student?.degree?.nameRu }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row col-md-9">
              <div class="el-input-group">
                <label class="form-label col-md-3">
                  Социальный статус
                </label>
                <div class="col-md-9">
                  {{ getStatus(student) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="student != null && student.socialPayment != null && student.socialPayment.additionalFinances != null">
        <div class="card" v-if="student.socialPayment.additionalFinances.length > 0">
          <div class="card-header">
            <h6>Дополнительное финансирование</h6>
          </div>
          <div class="card-body">
            <div class="col-md-12" v-for="item in student.socialPayment.additionalFinances">
              <div v-if="canShowAdditionalFinance(item)">
                <div class="row col-md-9" v-if="item.id === AdditionalFinancingEnum.DORMITORY_EXPENSES.id">
                  <div class="el-input-group">
                    <label class="form-label col-md-9">
                      {{ item.nameRu }}
                    </label>
                    <div class="col-md-3">
                      {{ item.sum }} * {{ student.socialPayment.monthsCount }} =
                      {{ item.sum * student.socialPayment.monthsCount }}
                    </div>
                  </div>
                </div>

                <div class="row col-md-9" v-if="item.id === AdditionalFinancingEnum.FOOD_ALLOWANCE.id">
                  <div class="el-input-group">
                    <label class="form-label col-md-9">
                      {{ item.nameRu }}
                    </label>
                    <div class="col-md-12">
                      <div v-if="item.formulaAdditional && item.formulaAdditional.length > 0">
                        {{ item.formula }}

                        <br/>

                        {{ item.formulaAdditional }} = {{ totalMealAmount.toFixed(2) }}
                      </div>
                      <div v-else>
                        {{ item.formula }} = {{ totalMealAmount.toFixed(2) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row col-md-9"
                     v-if="item.id === AdditionalFinancingEnum.GRADUATION_GRANT.id">
                  <div class="el-input-group">
                    <label class="form-label col-md-9">
                      {{ item.nameRu }}
                    </label>
                    <div class="col-md-3">
                      {{ item.sum }}
                    </div>
                  </div>
                </div>

                <div class="row col-md-9"
                     v-if="student.isFirstCourse && (item.id === AdditionalFinancingEnum.ENTRANCE_GRANT.id || item.id === AdditionalFinancingEnum.CLOTHING_AND_FOOTWEAR_EXPENSES.id)">
                  <div class="el-input-group">
                    <label class="form-label col-md-9">
                      {{ item.nameRu }}
                    </label>
                    <div class="col-md-3">
                      {{ item.sum }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            Общая сумма: {{ student.socialPayment.totalSum.toFixed(2) }}
          </div>
        </div>
      </div>

      <!-- Социальная выплата на питание -->
      <div class="card" v-if="hasAdditionalFinance(AdditionalFinancingEnum.FOOD_ALLOWANCE)">
        <div class="card-header">
          <h6>До 18 лет</h6>
        </div>
        <div class="card-body">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="workingDays" class="form-label col-md-5">
                Рабочие дни
              </label>
              <div class="col-md-7">
                <input
                    id="workingDays"
                    type="number"
                    v-model="student.socialPayment.workingDays"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="weekendDays" class="form-label col-md-5">
                Воскресные дни
              </label>
              <div class="col-md-7">
                <input
                    id="weekendDays"
                    type="number"
                    v-model="student.socialPayment.weekendDays"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="holidayDays" class="form-label col-md-5">
                Праздничные дни
              </label>
              <div class="col-md-7">
                <input
                    id="holidayDays"
                    type="number"
                    v-model="student.socialPayment.holidayDays"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="vacationDays" class="form-label col-md-5">
                Каникулярные дни
              </label>
              <div class="col-md-7">
                <input
                    id="vacationDays"
                    type="number"
                    v-model="student.socialPayment.vacationDays"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="hasAdditionalFinance(AdditionalFinancingEnum.FOOD_ALLOWANCE)">
        <div class="card-header">
          <h6>После 18 лет</h6>
        </div>
        <div class="card-body">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="workingDaysAdults" class="form-label col-md-5">
                Рабочие дни
              </label>
              <div class="col-md-7">
                <input
                    id="workingDaysAdults"
                    type="number"
                    v-model="student.socialPayment.workingDaysAdults"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="weekendDaysAdults" class="form-label col-md-5">
                Воскресные дни
              </label>
              <div class="col-md-7">
                <input
                    id="weekendDaysAdults"
                    type="number"
                    v-model="student.socialPayment.weekendDaysAdults"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="holidayDaysAdults" class="form-label col-md-5">
                Праздничные дни
              </label>
              <div class="col-md-7">
                <input
                    id="holidayDaysAdults"
                    type="number"
                    v-model="student.socialPayment.holidayDaysAdults"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="vacationDaysAdults" class="form-label col-md-5">
                Каникулярные дни
              </label>
              <div class="col-md-7">
                <input
                    id="vacationDaysAdults"
                    type="number"
                    v-model="student.socialPayment.vacationDaysAdults"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h6>Дополнительно</h6>
        </div>
        <div class="card-body">
          <!-- Количество месяцев -->
          <div class="row col-md-9" v-if="hasAdditionalFinance(AdditionalFinancingEnum.DORMITORY_EXPENSES)">
            <div class="el-input-group">
              <label for="monthsCount" class="form-label col-md-5">
                Количество месяцев проживание в обещежитии
              </label>
              <div class="col-md-7">
                <input
                    id="monthsCount"
                    type="number"
                    v-model="student.socialPayment.monthsCount"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    :min="0"
                    :step="1"
                    required
                />
              </div>
            </div>
          </div>

          <!-- Даты начала и окончания -->
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="startDate" class="form-label col-md-5">
                Дата начала действия соц. выплат
              </label>
              <div class="col-md-7">
                <input
                    id="startDate"
                    type="date"
                    v-model="student.socialPayment.startDate"
                    v-on:change="onChange()"
                    :disabled="isDisabled()"
                    class="form-control"
                    required
                />
              </div>
            </div>
          </div>

          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="endDate" class="form-label col-md-5">
                Дата окончания действия соц. выплат
              </label>
              <div class="col-md-7">
                <input
                    id="endDate"
                    type="date"
                    v-model="student.socialPayment.endDate"
                    :disabled="isDisabled()"
                    class="form-control"
                    required
                />
              </div>
            </div>
          </div>

          <!-- Подтверждающий документ -->
          <div class="row col-md-9">
            <div class="el-input-group">
              <label class="form-label col-md-5">
                Подтверждающий документ (PDF)
              </label>
              <div class="col-md-7" v-if="student.socialPayment.file">
                <a href="javascript:void(0)" @click="downloadFile(student.socialPayment.file.uuid)">
                  {{ student.socialPayment.file.name }}
                </a>

                <b-button variant="danger"
                          class="btn-sm"
                          style="margin-left: 20px"
                          v-if="canRemoveFile()"
                          @click="onClickRemoveFile()">
                  Удалить
                </b-button>
              </div>
              <div class="col-md-7" v-if="!student.socialPayment.file">
                <input type="file" required
                       :disabled="isDisabled()"
                       @change="handleFileUpload" accept=".pdf" class="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="canShowReason()">
        <div class="card-header">
          <h6>Причина отказа</h6>
        </div>
        <div class="card-body">
          <div class="row col-md-9">
            <div class="el-input-group">
              <label for="reason" class="form-label col-md-3">
                Причина отказа
              </label>
              <div class="col-md-9">
          <textarea v-model="student.socialPayment.reason"
                    :disabled="!canEditReason()"
                    id="reason"
                    style="width: 100%"
                    class="form-label" rows="5"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer justify-content-end">
      <div
          v-if="hasAccess(universityManagerRoles) && (!student.socialPayment.status || student.socialPayment.status === StudentApplicationStatusEnum.SENT_FOR_REVISION)">
        <b-button variant="success"
                  type="submit"
                  v-if="student.socialPayment.status == null || student.socialPayment.status === StudentApplicationStatusEnum.SENT_FOR_REVISION"
                  @click="setStatus(StudentApplicationStatusEnum.SENT_FOR_APPROVAL)">
          Отправить на согласование
        </b-button>
      </div>

      <div
          v-if="hasAccess(managerRoles) && student.socialPayment.status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL">
        <b-button variant="outline-info" class="btn-mr"
                  type="submit"
                  @click="setStatus(StudentApplicationStatusEnum.SENT_FOR_REVISION)">
          Отправить на доработку
        </b-button>

        <b-button variant="success" class="btn-mr"
                  type="submit"
                  @click="setStatus(StudentApplicationStatusEnum.APPROVED)">
          Принять
        </b-button>

        <b-button variant="danger" class="btn-mr"
                  type="submit"
                  @click="setStatus(StudentApplicationStatusEnum.REJECTED)">
          Отказать
        </b-button>
      </div>
    </div>
  </form>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import socialStatusService from "@/services/socialStatusService";
import studentSocialPaymentService from "@/services/studentSocialPaymentService";
import authService from "@/services/authService";
import {StudentApplicationStatusEnum} from "@/enum/StudentApplicationStatusEnum";
import fileService from "@/services/fileService";
import {AdditionalFinancingEnum} from "@/enum/AdditionalFinancingEnum";
import {SocialStatusEnum} from "@/enum/SocialStatusEnum";

export default {
  components: {
    VueLoading
  },
  computed: {
    AdditionalFinancingEnum() {
      return AdditionalFinancingEnum
    },
    StudentApplicationStatusEnum() {
      return StudentApplicationStatusEnum
    },
    studentUuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      startDate: null,
      student: {
        socialPayment: {
          uuid: null,
          additionalFinances: [],
          monthsCount: 0,
          workingDays: 0, // рабочие дни
          weekendDays: 0, // выходные дни
          holidayDays: 0, // праздничные дни
          vacationDays: 0, // каникулярные дни
          workingDaysAdults: 0, // рабочие дни
          weekendDaysAdults: 0, // выходные дни
          holidayDaysAdults: 0, // праздничные дни
          vacationDaysAdults: 0, // каникулярные дни
          totalSum: 0,
          startDate: null,
          endDate: null,
          status: null,
          reason: null,
          file: null
        },
        socialGroup: {
          socialStatusId: null
        },
        universityRegion: {
          mealAmount: null
        }
      },
      totalMealAmount: 0,
      yesNoList: [
        {id: true, nameRu: "Да"},
        {id: false, nameRu: "Нет"},
      ],
      socialStatuses: [],
      uploadedFile: null,
      status: null,
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles()
    };
  },
  methods: {
    init() {
      const startDate = new Date(new Date().getFullYear(), 8, 15, 0, 0, 0, 0);
      this.startDate = startDate.getTime();

      this.initSocialStatuses();
      this.findById(this.studentUuid);
    },
    async findById(studentUuid) {
      this.isLoading = true;
      this.student = await studentSocialPaymentService.findByStudentUuid(studentUuid);
      this.initStudentDefaultValues(this.student);

      this.onChange();

      this.isLoading = false;
    },
    initStudentDefaultValues(student) {
      if (student && student.socialPayment) {
        let additionalFinances = student.socialPayment.additionalFinances;
        if (additionalFinances) {
          additionalFinances = student.socialPayment.additionalFinances.sort((a, b) => a.id - b.id);

          if (student.socialPayment.monthsCount == null) {
            if (additionalFinances.some(a => a.id === AdditionalFinancingEnum.DORMITORY_EXPENSES.id)) {
              student.socialPayment.monthsCount = 0;
            }
          }
        }
      }
    },
    isValid() {
      if (!this.isEndDateValid()) {
        showErrorNotify("Дата окончания должна быть больше даты начала");
        return false;
      }

      return true;
    },
    isEndDateValid() {
      const {startDate, endDate} = this.student.socialPayment;
      return new Date(endDate) > new Date(startDate);
    },
    setStatus(status) {
      this.status = status;
    },
    setStatusAndSubmit(event) {
      if (this.status && this.status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
        if (!this.isValid()) {
          event.preventDefault();
          return;
        }
      }

      this.submitForm();
    },
    async submitForm() {
      try {
        this.isLoading = true;

        if (!this.student.socialPayment.file) {
          const formData = new FormData();
          formData.append('studentUuid', this.student.uuid);
          formData.append('file', this.uploadedFile);

          this.student.socialPayment.file = await fileService.uploadFile(formData);
        }

        this.student.socialPayment.status = this.status;

        this.student = await studentSocialPaymentService.save(this.student);
        this.initStudentDefaultValues(this.student);
        this.onChange();

        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    initSocialStatuses() {
      socialStatusService.getAll()
          .then(response => {
            this.socialStatuses = response.sort((a, b) => a.nameRu.localeCompare(b.nameRu));
          });
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadedFile = file;
      } else {
        showErrorNotify("Выберите файл для загрузки");
      }
    },
    hasAccess(...roleGroups) {
      const allRoles = roleGroups.flat();
      return authService.hasAccess(allRoles);
    },
    async downloadFile() {
      await fileService.download(this.student.socialPayment.file.uuid, this.student.socialPayment.file.name);
    },
    async onClickRemoveFile() {
      const confirmed = await confirm("Вы уверены, что хотите удалить данный файл?");
      if (confirmed) {
        try {
          await fileService.deleteFileById(this.student.socialPayment.file.uuid);
          this.student.socialPayment.file = null;

          showSuccessNotify('Успешно удалено');
        } catch (exc) {
          showErrorNotify('Возникла ошибка при удалении');
        }
      }
    },
    isDisabled() {
      const status = this.student.socialPayment.status;
      if (status && (status === StudentApplicationStatusEnum.APPROVED || status === StudentApplicationStatusEnum.REJECTED)) {
        return true;
      } else if (this.hasAccess(this.managerRoles)) {
        return true;
      } else if (this.hasAccess(this.universityManagerRoles)) {
        if (status && status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
          return true;
        }
        return false;
      }
      return true;
    },
    canRemoveFile() {
      if (this.hasAccess(this.universityManagerRoles)) {
        const status = this.student.socialPayment.status;
        if (!status || status === StudentApplicationStatusEnum.SENT_FOR_REVISION) {
          return true;
        }
      }
      return false;
    },
    canShowReason() {
      const status = this.student.socialPayment.status;
      if (status && status === StudentApplicationStatusEnum.APPROVED) {
        return false;
      }

      if (this.hasAccess(this.universityManagerRoles)) {
        if (!status) {
          return false;
        }

        if (status) {
          if (status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
            return false;
          }
        }
      }

      return true;
    },
    canEditReason() {
      const status = this.student.socialPayment.status;
      if (this.hasAccess(this.managerRoles)) {
        if (status && status === StudentApplicationStatusEnum.SENT_FOR_APPROVAL) {
          return true;
        }
      }
      return false;
    },
    hasAdditionalFinance(additionalFinanceType) {
      if (this.student == null || this.student.socialPayment == null) {
        return false;
      }

      const additionalFinances = this.student.socialPayment.additionalFinances;
      if (additionalFinances == null) {
        return false;
      }

      return additionalFinances.some(item => item.id === additionalFinanceType.id);
    },
    canShowAdditionalFinance(additionalFinanceType) {

      if (additionalFinanceType.id === AdditionalFinancingEnum.ENTRANCE_GRANT.id
          || additionalFinanceType.id === AdditionalFinancingEnum.CLOTHING_AND_FOOTWEAR_EXPENSES.id) {

        const startDateText = this.student.socialPayment.startDate;
        if (startDateText == null || this.student.isFirstCourse) {
          return true;
        }

        const startDate = new Date(startDateText);
        startDate.setHours(0, 0, 0, 0);

        const startDateValue = startDate.getTime();
        if (startDateValue > this.startDate) {
          return false;
        }
      }
      return true;
    },
    isOrphan(student) { // является ли сиротой
      if (student == null || student.socialGroup == null) {
        return false;
      }
      return student.socialGroup.socialStatusId === SocialStatusEnum.ORPHAN_WITHOUT_GUARDIANSHIP.id
          || student.socialGroup.socialStatusId === SocialStatusEnum.ORPHAN_WITH_GUARDIANSHIP.id;
    },
    isFromUniversity(university) {
      if (this.student == null) {
        return false;
      }
      return this.student.universityId === university.id;
    },
    calcTotalSum() {
      let totalSum = 0;

      if (this.student != null) {
        const socialPayment = this.student.socialPayment;
        if (socialPayment != null && socialPayment.additionalFinances != null) {
          for (let item of socialPayment.additionalFinances) {
            if (!this.canShowAdditionalFinance(item)) {
              continue;
            }

            item.formula = '';
            item.formulaAdditional = '';

            if (item.id === AdditionalFinancingEnum.DORMITORY_EXPENSES.id) {
              const monthsCount = socialPayment.monthsCount || 0;
              totalSum += item.sum * monthsCount;
            } else if (item.id === AdditionalFinancingEnum.FOOD_ALLOWANCE.id) {
              this.totalMealAmount = 0;

              if (this.student.socialPayment.workingDaysAdults == null) {
                this.student.socialPayment.workingDaysAdults = 0;
              }
              if (this.student.socialPayment.weekendDaysAdults == null) {
                this.student.socialPayment.weekendDaysAdults = 0;
              }
              if (this.student.socialPayment.holidayDaysAdults == null) {
                this.student.socialPayment.holidayDaysAdults = 0;
              }
              if (this.student.socialPayment.vacationDaysAdults == null) {
                this.student.socialPayment.vacationDaysAdults = 0;
              }

              const workingDays = this.student.socialPayment.workingDays || 0;
              const weekendDays = this.student.socialPayment.weekendDays || 0;
              const holidayDays = this.student.socialPayment.holidayDays || 0;
              const vacationDays = this.student.socialPayment.vacationDays || 0;

              const workingDaysAdults = this.student.socialPayment.workingDaysAdults || 0;
              const weekendDaysAdults = this.student.socialPayment.weekendDaysAdults || 0;
              const holidayDaysAdults = this.student.socialPayment.holidayDaysAdults || 0;
              const vacationDaysAdults = this.student.socialPayment.vacationDaysAdults || 0;

              const mealAmount = this.student.universityRegion.mealAmount || 0;

              if (this.isOrphan(this.student)) {
                const total = ((workingDays * mealAmount) + (weekendDays + holidayDays + vacationDays) * (mealAmount + mealAmount / 10)) * 0.4;
                const totalAdults = ((workingDaysAdults * mealAmount) + (weekendDaysAdults + holidayDaysAdults + vacationDaysAdults) * (mealAmount + mealAmount / 10));
                this.totalMealAmount = total + totalAdults;

                const formula = `((${workingDays} * ${mealAmount}) + (${weekendDays} + ${holidayDays} + ${vacationDays}) * (${mealAmount} + ${mealAmount} / 10)) * 0.4`;
                const formulaAdults = `((${workingDaysAdults} * ${mealAmount}) + (${weekendDaysAdults} + ${holidayDaysAdults} + ${vacationDaysAdults}) * (${mealAmount} + ${mealAmount} / 10))`;
                item.formula = `${formula} +`;
                item.formulaAdditional = `${formulaAdults}`;
              }

              totalSum += this.totalMealAmount;
            } else {
            if (item.id === AdditionalFinancingEnum.CLOTHING_AND_FOOTWEAR_EXPENSES.id) {
              if ( this.student.isFirstCourse) {
                totalSum += item.sum; // Расходы на одежду, обуви не учитываются в общей сумме кроме первокурсников
              }
            } else {
              totalSum += item.sum;
            }
          }
          }
        }
      }

      this.student.socialPayment.totalSum = totalSum;

      return totalSum;
    },
    onChange() {
      this.student.socialPayment.totalSum = this.calcTotalSum();
    },
    getStatus(student) {
      if (student === null) {
        return '';
      }

      if (student.socialGroup === null) {
        return '';
      }

      const socialStatusId = student.socialGroup.socialStatusId;
      if (socialStatusId === null) {
        return '';
      }

      const socialStatuses = this.socialStatuses.filter(s => s.id === socialStatusId);
      if (socialStatuses.length > 0) {
        return socialStatuses[0].nameRu || '';
      }
      return '';
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.btn-mr {
  margin-right: 15px;
}

.card {
  margin-bottom: 20px;
}
</style>
